<template>
  <div v-if="hasValidLocationInfo" class="travel-progress-bar">
    <ProgressBar :percent="currentPercent" />
    <div class="travel-icon-container">
      <div :class="['travel-icon', isCompleted ? 'travel-icon-completed' : 'travel-icon-progress']" :style="iconStyle">
        <i class="fas fa-truck"></i>
      </div>
    </div>
  </div>
</template>

<style scoped>
.travel-progress-bar {
  position: relative;
}
.travel-icon-container {
  position: absolute;
  left: 10px;
  right: 10px;
  top: 0;
  bottom: 0;
}
.travel-icon {
  position: absolute;
  top: 0;
  font-size: 2.1rem;
  color: #757997;
}
.travel-icon.travel-icon-completed {
  color: #3EB240;
}
.travel-icon > i {
  position: absolute;
  top: -10px;
  left: -10px;
}
</style>

<script>
import moment from 'moment'
import TimerMixin from '@/mixins/timer'

import ProgressBar from '@/components/progressBar'

export default {
  name: 'TaskItemTravelProgressBar',
  mixins: [TimerMixin],
  components: {
    ProgressBar
  },
  props: {
    taskItem: Object
  },
  data() {
    return {
      currentPercent: 0
    }
  },
  mounted() {
    this.currentPercent = this.calculatePercent()

    // Update every 30s
    this.createIntervalTimer('updater', () => {
      this.currentPercent = this.calculatePercent()
    }, 30000)
  },
  beforeDestroy() {
  },
  computed: {
    hasValidLocationInfo() {
      if(!this.taskItem)
        return false

      // Needs a start & estimated arrival dates to calculate the percentage
      // Note: This is purely based on start/end times, not with current GPS / Route data
      return (this.taskItem.startedDate && this.taskItem.estimatedArrivalDate)
    },
    isCompleted() {
      return this.currentPercent >= 100
    },
    iconStyle() {
      return {
        left: `${this.currentPercent}%`
      }
    }
  },
  methods: {
    calculatePercent() {
      if(!this.taskItem)
        return 0

      if(this.taskItem.isResourceArrived)
        return 100

      var startTS = moment(this.taskItem.startedDate).utc().unix()
      var endTS = moment(this.taskItem.estimatedArrivalDate).utc().unix()
      var currentTS = moment().utc().unix()

      if(endTS - startTS == 0)
        return 0

      var fraction = (currentTS - startTS) / (endTS - startTS)
      fraction = Math.min(Math.max(fraction, 0.0), 1.0)

      return Math.round(fraction * 100)
    },
  }
}
</script>